export default "__VITE_ASSET__Z3HzDRG4__"